import { ref } from 'vue';
import { DEMO_MODE_KEY, DEMO_BROWSING_KEY } from '@/storage/keys';

const key = DEMO_MODE_KEY;
export const demoEnabled = ref(typeof window !== 'undefined' && window.sessionStorage.getItem(key) === '1');

export function setDemoMode(enabled) {
  demoEnabled.value = enabled;
  if (enabled) window.sessionStorage.setItem(key, '1');
  else window.sessionStorage.removeItem(key);
}

export function isDemoMode() {
  return demoEnabled.value && !window.sessionStorage.getItem('accessToken');
}

// Only distinct pages count; reloads and filter/query changes do not trigger the prompt.
export function recordDemoVisit(path) {
  if (!isDemoMode()) return false;
  const storageKey = DEMO_BROWSING_KEY;
  let state;
  try { state = JSON.parse(window.sessionStorage.getItem(storageKey)); } catch { /* Recover an invalid tab record. */ }
  const paths = Array.isArray(state?.paths) ? state.paths.filter(p => typeof p === 'string').slice(0, 3) : [];
  const prompted = state?.prompted === true;
  if (!paths.includes(path) && paths.length < 3) paths.push(path);
  const shouldPrompt = !prompted && paths.length >= 3;
  window.sessionStorage.setItem(storageKey, JSON.stringify({ paths, prompted: prompted || shouldPrompt }));
  return shouldPrompt;
}
